import { Flag02Icon } from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Show } from "shared/components";
import { cx } from "shared/utils/classnames";
import { formatCalendar } from "views/boom-notifications/helpers/format-calendar";
import { channelConfig } from "./constants";
import { useInboxContext } from "../context/useInboxContext";
import { useInboxEmbed } from "../context/useInboxEmbed";
import { escalationLabel, type ConversationEscalation } from "../escalation";

const Dot = () => (
  <span className="size-1 shrink-0 rounded-full bg-content-100" aria-hidden />
);

export const EscalationBanner = ({
  conversationId,
  escalation
}: {
  conversationId?: string;
  escalation: ConversationEscalation | null;
}) => {
  const {
    actions: { selectConversation }
  } = useInboxContext();
  const compact = Boolean(useInboxEmbed()?.compact);

  if (!escalation) return null;

  const { reason, channel, at, messageId } = escalation;
  const channelLabel = channel
    ? (channelConfig[channel]?.label ?? channel)
    : null;
  const timeLabel = at ? formatCalendar(at) : null;

  return (
    <div
      role="status"
      className={cx(
        "flex flex-wrap items-center gap-x-3 gap-y-1 border-b border-alpha-80 bg-white text-content-300",
        compact ? "px-4 py-2 text-xs" : "px-6 py-3 text-sm"
      )}
    >
      <HugeiconsIcon
        icon={Flag02Icon}
        size={compact ? 14 : 16}
        className="shrink-0 text-danger-500"
      />
      <span className="font-bold text-content-1000">
        {escalationLabel(reason)}
      </span>
      <span className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1 font-medium">
        <Show if={Boolean(channelLabel)}>
          <span>{channelLabel}</span>
          <Dot />
        </Show>
        <Show if={Boolean(timeLabel)}>
          <span>{timeLabel}</span>
          <Dot />
        </Show>
        <span>clears when you reply</span>
      </span>
      <Show if={Boolean(messageId)}>
        <button
          type="button"
          onClick={() =>
            selectConversation(conversationId, messageId ?? undefined)
          }
          className="ml-auto font-bold text-primary-500 hover:text-primary-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-500"
        >
          See the message
        </button>
      </Show>
    </div>
  );
};
